import SystemKeyboardKeyItem from "../items/SystemKeyboardKeyItem";

export function PositiveIntegerKeyboard({onKeyButtonPressed, isKeyButtonDisabled}) {
    // Used through games and exercisers that expect positive decimal as
    // user answer

    // PROPERTIES
    const positiveIntegerKeys = [
        '1', '2', '3', '4', '5',
        '6', '7', '8', '9', '0'];

    // BUILD
    return (
        <div className="w-full grid grid-cols-5 gap-[12px]">
            {positiveIntegerKeys.map((item, index) => (
                <SystemKeyboardKeyItem key={index}
                                       item={item}
                                       onKeyButtonPressed={onKeyButtonPressed}
                                       isKeyButtonDisabled={isKeyButtonDisabled} />
            ))}
        </div>
    );
}